import { gql } from '@apollo/client';

export const GET_ALL_ACCOUNTS_FOR_SELECT = gql`
  query GetAllAccountsForSelect($name: String, $phone: String) {
    getAllAccountsForSelect(name: $name, phone: $phone) {
      id
      name
      phone
    }
  }
`;

export interface AccountForSelect {
  id: string;
  name: string;
  phone: string | null;
}

export interface GetAllAccountsForSelectResponse {
  getAllAccountsForSelect: AccountForSelect[];
}
